import { useState } from 'react';
import axios from 'axios';
import useGlobalState from 'utils/global-state';
import { UPDATE_USER_INFO, GDPR_NOT_CONFIRMED_ERROR } from 'utils/constants';

const useHttpClient = () => {
  const [{ userData }, dispatch] = useGlobalState();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const defaultHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  const sendRequest = async (
    url,
    method = 'GET',
    data = null,
    customHeaders = null,
  ) => {
    setIsLoading(true);
    const authorizationHeaders = userData
      ? { Authorization: `Bearer ${userData.token}` }
      : {};
    const headers = {
      ...defaultHeaders,
      ...authorizationHeaders,
      ...(customHeaders || {}),
    };

    try {
      const response = await axios(url, { method, data, headers });
      setIsLoading(false);

      return response.data;
    } catch (error) {
      setIsLoading(false);
      setHasError(true);

      if (error.response?.data?.error === GDPR_NOT_CONFIRMED_ERROR) {
        dispatch({ type: UPDATE_USER_INFO, payload: { isGdprConfirmed: false } });
      }

      throw error;
    }
  };

  return { sendRequest, isLoading, hasError };
};

export default useHttpClient;
